export const navbarLinks = [
  { label: "首页", href: "#hero" },
  { label: "热门话题", href: "#topics" },
  { label: "特色专栏", href: "#features" },
  { label: "吃瓜排行", href: "#ranking" },
  { label: "关于我们", href: "#about" },
  { label: "网友评论", href: "#comments" },
];

export const heroData = {
  tagline: "🔥 实时追踪 · 全网聚合",
  h1: "51吃瓜网站 — 全网最新吃瓜资源一站式聚合平台",
  slogan: "吃瓜不迷路，全网黑料一手掌握，每日更新热门八卦与争议内幕",
  intro: "51吃瓜网站作为国内领先的娱乐八卦聚合平台，全天候追踪全网热点爆料、明星黑料与争议事件。我们从微博、豆瓣、抖音、小红书等主流社交渠道实时采集最新51吃瓜网今日吃瓜资源，覆盖51吃瓜爆料、51吃瓜黑料、51吃瓜在线观看视频等核心内容板块，以「快、全、深」为运营标准，确保每一位吃瓜爱好者不错过任何一条重磅内幕。无论是娱乐圈塌房实录、网红翻车现场，还是综艺节目幕后争议，这里都是你的一站式吃瓜大全。",
  stats: [
    { value: "200+", label: "每日新增爆料" },
    { value: "50+", label: "覆盖娱乐平台" },
    { value: "7×24h", label: "不间断追踪更新" },
  ],
  primaryCta: { label: "立即吃瓜", href: "#cards" },
  secondaryCta: { label: "查看热榜", href: "#ranking" },
};

export const cardsData = [
  {
    title: "顶流男星深夜密会神秘女子，酒店共度8小时引热议",
    summary: "有网友爆料拍到某顶流男星与一名身份不明女子深夜先后进入同一酒店，次日清晨才分别离开，粉丝纷纷要求工作室回应。",
    tag: "塌房预警",
    time: "2小时前",
    views: "128.6万",
    image: "https://readdy.ai/api/search-image?query=dark%20silhouette%20of%20a%20person%20walking%20into%20luxury%20hotel%20at%20night%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20vibe%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=500&seq=card-01-gossip&orientation=landscape",
  },
  {
    title: "某女团成员被曝与经纪公司解约纠纷，千万违约金细节流出",
    summary: "据知情人士透露，该女团成员因不满资源分配与公司产生严重分歧，解约谈判已持续三个月，涉及违约金高达千万级别。",
    tag: "独家爆料",
    time: "5小时前",
    views: "96.3万",
    image: "https://readdy.ai/api/search-image?query=dramatic%20contract%20document%20on%20dark%20desk%20with%20stage%20spotlight%20reflection%2C%20legal%20drama%20atmosphere%2C%20elegant%20office%20setting%2C%20warm%20amber%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=card-02-contract&orientation=landscape",
  },
  {
    title: "综艺节目录制现场爆发激烈冲突，导演组紧急叫停",
    summary: "某热门综艺最新一期录制过程中，两位常驻嘉宾因游戏环节产生口角，随后升级为肢体推搡，节目组被迫中断录制进行调解。",
    tag: "现场直击",
    time: "8小时前",
    views: "215.7万",
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20lighting%2C%20two%20shadow%20figures%20facing%20off%2C%20stage%20equipment%20in%20background%2C%20intense%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20tones&width=800&height=500&seq=card-03-variety&orientation=landscape",
  },
  {
    title: "网红主播偷税漏税被罚数千万，直播账号永久封禁",
    summary: "税务部门最新通报显示，某知名带货主播通过隐匿收入、虚假申报等方式偷逃税款，已被追缴并处罚款合计超3000万元。",
    tag: "黑料实锤",
    time: "12小时前",
    views: "302.1万",
    image: "https://readdy.ai/api/search-image?query=modern%20office%20with%20financial%20documents%20scattered%20on%20desk%2C%20dark%20moody%20lighting%2C%20dramatic%20shadows%2C%20professional%20photography%20style%2C%20warm%20deep%20tones%2C%20cinematic%20aesthetic&width=800&height=500&seq=card-04-tax&orientation=landscape",
  },
  {
    title: "知名导演新片选角内幕曝光，带资进组潜规则再引争议",
    summary: "多位业内人士爆料某知名导演新片选角存在暗箱操作，多位投资方推荐的演员未经试镜直接进组，引发行业热议。",
    tag: "深度扒皮",
    time: "1天前",
    views: "187.4万",
    image: "https://readdy.ai/api/search-image?query=film%20director%20chair%20on%20empty%20movie%20set%20with%20dramatic%20spotlight%2C%20backstage%20atmosphere%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20film%20industry%20vibe&width=800&height=500&seq=card-05-casting&orientation=landscape",
  },
  {
    title: "跨国婚姻明星夫妇被传婚变，双方工作室沉默应对",
    summary: "近期有网友发现某跨国明星夫妇已超过半年未在社交平台互动，且各自删除大量合照，婚变传闻愈演愈烈但双方均未回应。",
    tag: "情感八卦",
    time: "1天前",
    views: "256.8万",
    image: "https://readdy.ai/api/search-image?query=two%20wedding%20rings%20placed%20apart%20on%20dark%20marble%20surface%2C%20emotional%20drama%20atmosphere%2C%20soft%20warm%20lighting%2C%20elegant%20still%20life%20photography%2C%20melancholic%20mood&width=800&height=500&seq=card-06-divorce&orientation=landscape",
  },
  {
    title: "选秀节目出道组被曝集体霸凌队友，多段录音曝光",
    summary: "一段疑似选秀节目出道组成员私下霸凌未出道队友的录音在网络上疯传，录音内容涉及人身攻击和威胁言论，引发舆论强烈谴责。",
    tag: "重磅黑料",
    time: "2天前",
    views: "478.9万",
    image: "https://readdy.ai/api/search-image?query=empty%20dance%20practice%20room%20with%20dim%20lighting%2C%20mirrored%20walls%20reflecting%20dark%20shadows%2C%20dramatic%20atmosphere%2C%20K-pop%20style%20setting%2C%20warm%20contrast%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=card-07-bullying&orientation=landscape",
  },
];

export const updatesData = [
  { time: "10:42", content: "某知名歌手被拍到与经纪人深夜同回公寓，恋情疑似曝光", hot: true },
  { time: "09:15", content: "热门电视剧剧组被曝拖欠群演工资，制片方紧急回应", hot: true },
  { time: "07:30", content: "某男团成员直播中突然情绪失控，疑似与公司矛盾有关", hot: false },
  { time: "06:22", content: "综艺节目后期剪辑人员爆料：某嘉宾镜头被大量删减", hot: true },
  { time: "03:18", content: "某女星品牌代言被紧急撤换，原因引发多方猜测", hot: false },
  { time: "01:05", content: "深夜爆料号发文暗示某顶流将有大瓜，引发网友疯狂猜测", hot: true },
  { time: "昨天 23:40", content: "某知名编剧实名举报同行抄袭，附详细对比证据", hot: false },
  { time: "昨天 21:55", content: "热门网红城市打卡地被曝宰客，游客投诉量激增", hot: false },
];

export const featuresData = [
  {
    icon: "ri-flashlight-line",
    title: "全网极速追踪",
    desc: "7×24小时实时监控微博、豆瓣、抖音、小红书等50+主流平台，第一时间抓取51吃瓜爆料与黑料信息，吃瓜快人一步。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多方交叉验证",
    desc: "每条51吃瓜黑料均经过多信源交叉核实，标注「待证实」「已实锤」等可信度标签，拒绝虚假谣言，守护吃瓜品质。",
  },
  {
    icon: "ri-folders-line",
    title: "事件深度归档",
    desc: "为每一桩重大八卦建立完整时间线与人物关系图谱，从起因到反转全程记录，让你吃瓜吃得明明白白。",
  },
  {
    icon: "ri-smartphone-line",
    title: "移动端随时吃瓜",
    desc: "支持51吃瓜在线观看视频和图文快讯，手机端优化阅读体验，通勤、摸鱼、睡前随时随地掌握最新爆料。",
  },
  {
    icon: "ri-user-voice-line",
    title: "吃瓜群众社区",
    desc: "开放评论区自由讨论，热门话题支持投票和观点PK，让你在吃瓜的同时找到志同道合的吃瓜搭子。",
  },
];

export const topicsData = [
  { name: "顶流塌房实录", count: "2,847条", hot: true, color: "bg-red-500" },
  { name: "选秀黑幕合集", count: "1,923条", hot: true, color: "bg-orange-500" },
  { name: "网红翻车现场", count: "3,156条", hot: true, color: "bg-amber-500" },
  { name: "综艺争议大盘点", count: "1,658条", hot: false, color: "bg-rose-400" },
  { name: "明星婚姻八卦", count: "2,301条", hot: false, color: "bg-pink-400" },
  { name: "剧组内幕爆料", count: "987条", hot: false, color: "bg-fuchsia-400" },
  { name: "品牌代言风波", count: "1,234条", hot: false, color: "bg-cyan-400" },
  { name: "直播带货打假", count: "2,089条", hot: true, color: "bg-emerald-500" },
  { name: "海外吃瓜速递", count: "756条", hot: false, color: "bg-teal-400" },
];

export const mediaData = [
  {
    title: "深扒某顶流五年上位史：资本运作全解析",
    duration: "15:28",
    views: "526.3万",
    image: "https://readdy.ai/api/search-image?query=dark%20luxurious%20office%20with%20dramatic%20spotlight%20on%20empty%20chair%2C%20power%20and%20wealth%20symbolism%2C%20warm%20golden%20accents%2C%20cinematic%20investigative%20style%2C%20mysterious%20atmosphere&width=800&height=600&seq=media-01-expose&orientation=landscape",
  },
  {
    title: "娱乐圈资本局：谁在操控你看到的热搜？",
    duration: "22:10",
    views: "389.7万",
    image: "https://readdy.ai/api/search-image?query=digital%20screen%20displaying%20social%20media%20trending%20topics%20in%20Chinese%2C%20dark%20control%20room%20atmosphere%2C%20warm%20red%20accents%2C%20tech%20noir%20style%2C%20cinematic%20lighting&width=800&height=600&seq=media-02-capital&orientation=landscape",
  },
  {
    title: "塌房预警：近期可能暴雷的十位明星盘点",
    duration: "18:45",
    views: "712.4万",
    image: "https://readdy.ai/api/search-image?query=cracked%20concrete%20wall%20with%20dramatic%20light%20shining%20through%2C%20metaphorical%20destruction%20imagery%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%2C%20intense%20atmosphere&width=800&height=600&seq=media-03-warning&orientation=landscape",
  },
  {
    title: "从素人到顶流：那些被资本选中的幸运儿",
    duration: "25:33",
    views: "441.2万",
    image: "https://readdy.ai/api/search-image?query=single%20spotlight%20on%20empty%20stage%20with%20staircase%20leading%20upward%2C%20dramatic%20theater%20setting%2C%20warm%20golden%20lighting%2C%20aspirational%20atmosphere%2C%20cinematic%20aesthetic&width=800&height=600&seq=media-04-rise&orientation=landscape",
  },
  {
    title: "2025娱乐圈大事件年终盘点：瓜田丰收的一年",
    duration: "31:12",
    views: "893.5万",
    image: "https://readdy.ai/api/search-image?query=film%20reel%20and%20dramatic%20theater%20masks%20on%20dark%20stage%2C%20celebration%20and%20drama%20symbolism%2C%20warm%20theater%20lighting%2C%20cinematic%20composition%2C%20entertainment%20industry%20theme&width=800&height=600&seq=media-05-year&orientation=landscape",
  },
];

export const carouselData = [
  {
    title: "「塌房2025」年度盘点专题",
    desc: "回顾今年最震撼的明星塌房事件，从顶流偶像到实力派演员，谁的人设崩塌最令人意外？完整梳理事件始末与后续走向。",
    tag: "年度专题",
    color: "from-red-600 to-rose-700",
    image: "https://readdy.ai/api/search-image?query=dramatic%20collapsing%20theater%20set%20with%20fallen%20spotlights%2C%20metaphorical%20destruction%20of%20fame%2C%20warm%20red%20and%20gold%20lighting%2C%20cinematic%20disaster%20aesthetic%2C%20emotional%20atmosphere&width=1400&height=700&seq=carousel-01-collapse&orientation=landscape",
  },
  {
    title: "「黑料考古」经典大瓜回顾",
    desc: "翻出那些年轰动全网的经典黑料事件，从最初爆料到最终实锤，带你重温那些令人瞠目结舌的娱乐圈秘闻与惊天反转。",
    tag: "经典回顾",
    color: "from-amber-600 to-orange-700",
    image: "https://readdy.ai/api/search-image?query=old%20newspaper%20clippings%20and%20vintage%20magnifying%20glass%20on%20dark%20wooden%20desk%2C%20investigative%20journalism%20atmosphere%2C%20warm%20sepia%20lighting%2C%20mysterious%20vibe%2C%20cinematic%20composition&width=1400&height=700&seq=carousel-02-archive&orientation=landscape",
  },
  {
    title: "「选秀内幕」解密系列专题",
    desc: "深度起底各大选秀节目背后的资本游戏与内定规则，从投票机制到出道位分配，揭开选秀产业链不为人知的真相。",
    tag: "深度调查",
    color: "from-fuchsia-600 to-purple-700",
    image: "https://readdy.ai/api/search-image?query=empty%20audition%20room%20with%20judges%20table%20and%20single%20microphone%20under%20dramatic%20spotlight%2C%20talent%20show%20backstage%2C%20warm%20rose%20lighting%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=1400&height=700&seq=carousel-03-talent&orientation=landscape",
  },
  {
    title: "「网红翻车」年度合集大盘点",
    desc: "从带货翻车到人设崩塌，盘点今年最离谱的网红翻车现场。那些曾经风光无限的网红们，是如何一步步走向舆论深渊的？",
    tag: "翻车合集",
    color: "from-emerald-600 to-teal-700",
    image: "https://readdy.ai/api/search-image?query=smartphone%20screen%20cracking%20dramatically%20with%20social%20media%20icons%20fading%2C%20digital%20downfall%20symbolism%2C%20warm%20dark%20lighting%2C%20cinematic%20drama%2C%20intense%20atmosphere&width=1400&height=700&seq=carousel-04-influencer&orientation=landscape",
  },
  {
    title: "「娱乐资本局」产业深度分析",
    desc: "谁在操控娱乐圈的头条新闻？从经纪公司到营销号产业链，深度剖析娱乐资本如何制造话题、引导舆论、收割流量。",
    tag: "产业分析",
    color: "from-slate-600 to-gray-700",
    image: "https://readdy.ai/api/search-image?query=modern%20skyscraper%20boardroom%20with%20dramatic%20city%20view%20through%20windows%2C%20corporate%20power%20symbolism%2C%20warm%20golden%20evening%20lighting%2C%20cinematic%20composition%2C%20luxury%20atmosphere&width=1400&height=700&seq=carousel-05-capital&orientation=landscape",
  },
];

export const rankingData = [
  { rank: 1, title: "顶流男星深夜密会神秘女子", heat: "🔥 1286万热度", change: "up" },
  { rank: 2, title: "网红主播偷税被罚数千万", heat: "🔥 1102万热度", change: "up" },
  { rank: 3, title: "选秀节目霸凌录音曝光事件", heat: "🔥 978万热度", change: "new" },
  { rank: 4, title: "综艺录制现场嘉宾冲突", heat: "🔥 815万热度", change: "down" },
  { rank: 5, title: "跨国明星夫妇婚变传闻", heat: "🔥 756万热度", change: "up" },
];

export const aboutData = {
  title: "51吃瓜网站 — 你的全网吃瓜第一站",
  paragraphs: [
    "51吃瓜网站创立于2023年，是国内领先的娱乐八卦与热点爆料聚合平台。我们致力于为吃瓜爱好者提供最全面、最及时、最可靠的51吃瓜网今日吃瓜资源，覆盖明星塌房、网红翻车、综艺内幕、选秀黑料等全品类娱乐资讯。",
    "平台采用智能聚合+人工审核双轨机制，实时追踪微博超话、豆瓣小组、抖音热榜、小红书话题等50余个主流内容源，确保每一条51吃瓜爆料都有据可查、每条51吃瓜黑料都经过多信源交叉验证。我们标注的可信度标签体系，帮助用户在海量信息中快速辨别真伪。",
    "从51吃瓜在线观看视频到图文深度扒皮，从即时快讯到事件时间线梳理，51吃瓜网站已构建起完整的吃瓜内容生态。无论你是追星族、八卦爱好者还是娱乐产业观察者，这里都是你不可错过的一站式吃瓜大全。",
  ],
};

export const indexData = [
  { title: "51吃瓜爆料 · 最新动态", count: "12,847篇", desc: "全网最新鲜的吃瓜爆料资讯实时更新" },
  { title: "51吃瓜黑料 · 实锤档案", count: "8,392篇", desc: "经过多方核实的明星网红黑料合集" },
  { title: "51吃瓜视频 · 在线观看", count: "5,621部", desc: "热门吃瓜事件的视频解读与现场直击" },
  { title: "娱乐圈 · 明星八卦", count: "16,203篇", desc: "明星绯闻、恋情、婚变等娱乐八卦大全" },
  { title: "综艺内幕 · 选秀揭秘", count: "4,718篇", desc: "热门综艺和选秀节目的幕后真相揭秘" },
  { title: "直播带货 · 翻车实录", count: "3,542篇", desc: "网红主播带货翻车与虚假宣传曝光记录" },
  { title: "海外吃瓜 · 国际速递", count: "2,156篇", desc: "K-pop、欧美娱乐圈最新八卦资讯速递" },
];

export const contactData = {
  title: "投稿爆料 · 商务合作",
  desc: "你有独家黑料想要曝光？有重大八卦线索想要提供？或者希望与51吃瓜网站进行商业合作？欢迎通过以下方式联系我们，我们承诺对爆料人信息严格保密。",
  email: "tougao@51chigua.com",
  tips: "爆料须知：请提供尽可能详细的证据材料（图片、录音、聊天记录等），单方面口述无证据的爆料将不予采纳。",
};

export const faqData = [
  {
    q: "51吃瓜网站的爆料信息可信吗？",
    a: "我们采用「多信源交叉验证」机制，每条爆料都会标注可信度等级：🟢 已实锤（多方证实）、🟡 待证实（单一信源）、🔴 存疑（仅网络传言）。建议用户结合可信度标签自行判断。",
  },
  {
    q: "如何在51吃瓜网在线观看视频内容？",
    a: "进入「51吃瓜在线观看」板块即可浏览所有视频内容，支持桌面端和移动端播放，无需下载任何应用。视频内容涵盖事件解读、现场直击、深度分析等多种类型。",
  },
  {
    q: "51吃瓜网站多久更新一次内容？",
    a: "我们的内容团队7×24小时不间断追踪全网热点，重大爆料事件通常在15分钟内上线首条快讯，30分钟内完成多信源验证，1小时内发布完整报道。日常内容每小时至少更新一批。",
  },
  {
    q: "我可以向51吃瓜网站投稿爆料吗？",
    a: "当然可以！欢迎通过「联系我们」板块提交你的独家爆料，我们为爆料人提供严格的身份保密机制。如果爆料被采纳并发布，你将获得专属的「吃瓜先锋」认证标识。",
  },
  {
    q: "51吃瓜网站的「吃瓜排行」是如何计算的？",
    a: "吃瓜排行综合了阅读量、评论数、分享数、搜索热度等多个维度，通过自研算法实时计算得出。排名每小时自动更新一次，确保用户看到的是当下最热门的吃瓜内容。",
  },
];

export const commentsData = [
  {
    avatar: "https://readdy.ai/api/search-image?query=abstract%20geometric%20avatar%20with%20warm%20coral%20and%20peach%20tones%2C%20minimalist%20style%2C%20clean%20background%2C%20modern%20design&width=200&height=200&seq=avatar-01&orientation=squarish",
    name: "吃瓜一线猹",
    time: "3小时前",
    content: "这个网站太强了！我关注的几个大瓜都是在这里第一时间看到的，比微博热搜还快！而且每条爆料都有可信度标签，比外面那些瞎编乱造的自媒体靠谱太多了。",
    likes: "2.3k",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=abstract%20geometric%20avatar%20with%20warm%20amber%20and%20orange%20tones%2C%20minimalist%20style%2C%20clean%20background%2C%20modern%20design&width=200&height=200&seq=avatar-02&orientation=squarish",
    name: "瓜田守望者",
    time: "8小时前",
    content: "吃瓜排行的设计真的绝，每天打开看一眼就知道今天什么瓜最火。那个时间线梳理功能也很棒，塌房事件从头到尾给你理得清清楚楚，吃瓜体验满分！",
    likes: "1.8k",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=abstract%20geometric%20avatar%20with%20warm%20rose%20and%20pink%20tones%2C%20minimalist%20style%2C%20clean%20background%2C%20modern%20design&width=200&height=200&seq=avatar-03&orientation=squarish",
    name: "无情吃瓜机器",
    time: "1天前",
    content: "作为一个资深吃瓜人，51吃瓜真的是我用过最全的吃瓜平台。从明星八卦到网红翻车，从综艺内幕到选秀黑料，内容覆盖面太广了。唯一的问题就是——瓜太多，根本吃不完！",
    likes: "3.1k",
  },
];